import React from "react";
import SelectedScenario from "./SelectedScenario";

function getScenarioNickname(scenario: SelectedScenario) {
  return (
    (scenario !== undefined &&
      scenario.params &&
      scenario.params[0] &&
      (scenario.params[0].currentModeStates[scenario.params[0].currentModeIndex] as string)) ||
    scenario.scenario
  );
}

function snackbarScenarioChange(
  addSnackbarMessage: (title: string, message: string) => void,
  scenario: SelectedScenario | string | undefined
) {
  if (scenario) {
    addSnackbarMessage(
      (typeof scenario === "string" ? scenario : getScenarioNickname(scenario)).trim() + " forecast selected!",
      "You'll see your selection's future projections reflected in the Overview page."
    );
  }
}

export default snackbarScenarioChange;
